export default "__VITE_ASSET__C_4QnaGo__"